import React from 'react';
import PropTypes from 'prop-types';

import { Wheel } from '../../Wheel';
import ITEMS from './constants';
import RouletteInsideImage from './roulette.png';
import { RouletteImage } from './styles';

function RouletteCasino({ data, styles }) {
  const dataItems = ITEMS.map((item) => ({
    option: item.text,
    style: {
      backgroundColor: item.background,
      fontSize: item.fontSize,
      textColor: item.color,
    },
  }));

  return (
    <Wheel
      mustStartSpinning={data.mustSpin}
      prizeNumber={data.prizeNumber}
      data={dataItems}
      outerBorderColor="#FAE075"
      outerBorderWidth={10}
      innerRadius={50}
      innerBorderColor="#FAE075"
      innerBorderWidth={25}
      radiusLineColor="#FAE075"
      radiusLineWidth={2}
      perpendicularText
      selectorColor={styles?.selector?.background}
      textDistance={80}
    >
      {styles?.image?.show && (
        <RouletteImage src={RouletteInsideImage} alt="roulette-static" />
      )}
    </Wheel>
  );
}

RouletteCasino.propTypes = {
  data: PropTypes.shape({
    mustSpin: PropTypes.bool,
    prizeNumber: PropTypes.number,
  }),
  styles: PropTypes.shape({
    image: PropTypes.shape({
      show: PropTypes.bool,
    }),
    selector: PropTypes.shape({
      background: PropTypes.string,
    }),
  }),
};

RouletteCasino.defaultProps = {
  data: {
    mustSpin: false,
    prizeNumber: 0,
  },
  styles: {
    image: {
      show: true,
    },
    selector: {
      background: '#e24a2b',
    },
  },
};

export default RouletteCasino;
